var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0027 41.5615C51.8493 41.5615 57.3875 38.8172 60.9466 34.2021C57.3875 29.5783 51.8486 26.8424 46.0027 26.8424C41.9191 26.8424 38.044 28.0401 34.8011 30.3017C34.7515 30.3348 34.7098 30.3599 34.6595 30.385L48.9467 16.0978C49.2793 15.7652 49.2793 15.2328 48.9467 14.9002C48.6141 14.5675 48.0818 14.5675 47.7492 14.9002L33.8779 28.7715C36.115 25.6277 37.304 21.9608 37.304 18.1439C37.304 12.2973 34.5597 6.75898 29.9445 3.2C25.3206 6.75896 22.5849 12.298 22.5849 18.1439C22.5849 24.0234 25.1877 29.3621 29.7533 32.9054L14.9093 47.7493C17.1465 44.6055 18.3354 40.9388 18.3354 37.1218C18.3354 31.2752 15.5911 25.737 10.9759 22.1778C6.35206 25.7369 3.61632 31.2759 3.61632 37.1218C3.61632 43.0013 6.21918 48.3399 10.7847 51.8832L2.80947 59.8584C2.47684 60.1911 2.47684 60.7233 2.80947 61.0559C2.97615 61.2226 3.1917 61.3053 3.40799 61.3053C3.62428 61.3053 3.84042 61.222 4.00637 61.0559L11.9816 53.0808C15.5824 57.7046 21.2874 60.5488 27.0506 60.5488C32.8971 60.5488 38.4354 57.8044 41.9945 53.1894C38.4354 48.5655 32.8965 45.8298 27.0506 45.8298C22.9671 45.8298 19.0919 47.0274 15.8488 49.2889C15.7994 49.322 15.7576 49.3472 15.7074 49.3723L30.9674 34.1123C34.5431 38.7173 40.2482 41.5615 46.0027 41.5615Z",
    fill: "url(#paint0_linear_268_559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0027 41.5615C51.8493 41.5615 57.3875 38.8172 60.9466 34.2021C57.3875 29.5783 51.8486 26.8424 46.0027 26.8424C41.9191 26.8424 38.044 28.0401 34.8011 30.3017C34.7515 30.3348 34.7098 30.3599 34.6595 30.385L48.9467 16.0978C49.2793 15.7652 49.2793 15.2328 48.9467 14.9002C48.6141 14.5675 48.0818 14.5675 47.7492 14.9002L33.8779 28.7715C36.115 25.6277 37.304 21.9608 37.304 18.1439C37.304 12.2973 34.5597 6.75898 29.9445 3.2C25.3206 6.75896 22.5849 12.298 22.5849 18.1439C22.5849 24.0234 25.1877 29.3621 29.7533 32.9054L14.9093 47.7493C17.1465 44.6055 18.3354 40.9388 18.3354 37.1218C18.3354 31.2752 15.5911 25.737 10.9759 22.1778C6.35206 25.7369 3.61632 31.2759 3.61632 37.1218C3.61632 43.0013 6.21918 48.3399 10.7847 51.8832L2.80947 59.8584C2.47684 60.1911 2.47684 60.7233 2.80947 61.0559C2.97615 61.2226 3.1917 61.3053 3.40799 61.3053C3.62428 61.3053 3.84042 61.222 4.00637 61.0559L11.9816 53.0808C15.5824 57.7046 21.2874 60.5488 27.0506 60.5488C32.8971 60.5488 38.4354 57.8044 41.9945 53.1894C38.4354 48.5655 32.8965 45.8298 27.0506 45.8298C22.9671 45.8298 19.0919 47.0274 15.8488 49.2889C15.7994 49.322 15.7576 49.3472 15.7074 49.3723L30.9674 34.1123C34.5431 38.7173 40.2482 41.5615 46.0027 41.5615Z",
    fill: "url(#paint1_linear_268_559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02805 10.0369C8.3611 10.0369 10.2524 8.14563 10.2524 5.81259C10.2524 3.47955 8.3611 1.58824 6.02805 1.58824C3.69501 1.58824 1.80371 3.47955 1.80371 5.81259C1.80371 8.14563 3.69501 10.0369 6.02805 10.0369Z",
    fill: "url(#paint2_linear_268_559)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02805 10.0369C8.3611 10.0369 10.2524 8.14563 10.2524 5.81259C10.2524 3.47955 8.3611 1.58824 6.02805 1.58824C3.69501 1.58824 1.80371 3.47955 1.80371 5.81259C1.80371 8.14563 3.69501 10.0369 6.02805 10.0369Z",
    fill: "url(#paint3_linear_268_559)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8666 64C59.5455 64 62.5278 61.0177 62.5278 57.3388C62.5278 53.6599 59.5455 50.6776 55.8666 50.6776C52.1877 50.6776 49.2054 53.6599 49.2054 57.3388C49.2054 61.0177 52.1877 64 55.8666 64Z",
    fill: "url(#paint4_linear_268_559)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8666 64C59.5455 64 62.5278 61.0177 62.5278 57.3388C62.5278 53.6599 59.5455 50.6776 55.8666 50.6776C52.1877 50.6776 49.2054 53.6599 49.2054 57.3388C49.2054 61.0177 52.1877 64 55.8666 64Z",
    fill: "url(#paint5_linear_268_559)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_559",
    x1: 2.56,
    y1: 32.2526,
    x2: 60.9466,
    y2: 32.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D85D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_268_559",
    x1: 2.56,
    y1: 32.2526,
    x2: 60.9466,
    y2: 32.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_268_559",
    x1: 1.80371,
    y1: 5.81258,
    x2: 10.2524,
    y2: 5.81258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D85D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_268_559",
    x1: 1.80371,
    y1: 5.81258,
    x2: 10.2524,
    y2: 5.81258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_268_559",
    x1: 49.2054,
    y1: 57.3388,
    x2: 62.5278,
    y2: 57.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D85D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_268_559",
    x1: 49.2054,
    y1: 57.3388,
    x2: 62.5278,
    y2: 57.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cd9d9d48f76974271ff816d1e12dbab1.svg";
export { ForwardRef as ReactComponent };